<script>
    export default {
        props: ['company', 'editable'],
        mounted () {   
          
        },
        data() {
            return {
                foo: "bar",
                editing: false
            }
        },
        methods: {      
          dismiss() {
            this.editing = false;
          },
          openModal() {
            console.log("openModal video")
            this._company = this.company
            this.editing = true
          },
          save() {
            // this.company.description = this.desc
            this.company = this._company
            console.log("emitting save")
            this.$emit('save')
            this.editing=false
          }          
        }
        
    }
</script>



<template lang="pug">

.foo
  #video-div.z-depth-1
    .row.edit-div(v-if="editable")
      .col.s12.right-align
        img.edit-icon.modal-trigger(data-target='industry-video-modal' src='@/assets/svg/bluepencil.svg'
        @click="openModal")
    #no-video.edit-div.valign-wrapper( v-if="!company.videoUrl && editable" )
      .row
        img.add-video-icon.edit-icon.modal-trigger(data-target='industry-video-modal' src='@/assets/svg/addvideo.svg'
        @click="openModal")
        br
        span Upload a video from or about your organization!
    #video( v-else )
      iframe#company-vid(v-if="company.videoUrl" controls="1" :src="company.videoUrl")
      .no-video-view-only.valign-wrapper(v-else) No video available
  #industry-video-modal( v-if="editing" )
    .modal-overlay2(@click="dismiss")
      .modal-content( @click.stop="" )
        .row
          .col.s12.header-lgn
            h5.center-align Upload Video
            hr
        .row.instructions
          .col.s12.center-align
            h6
              | Paste URL of a video for people to see.
            h6
              | Make sure you copy paste the url from the search bar in the browser.
            .youtube
              h6 
                | If you are using YouTube, choose Share -&gt; Embed, copy the code it provides, and pull out only the embedded URL. See the bolded section:
              pre
                | &lt;iframe width="560" height="315" src="
                b https://www.youtube.com/embed/_ZNY1j7Iyq0
                | " frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen&gt;&lt;/iframe&gt;
            form
              .input-field
                  //p.form-label Video URL:
                  input#company-video.input-div(type='url' name="company-video" required v-model="_company.videoUrl")
        .row
          .col.s12.close-btn-div
            button.close-btn.modal-close#save-company-info(type='button' @click="save") SAVE
          .col.s12.close-btn-div
            button.close-btn.modal-close(type='button' @click="dismiss") CANCEL

</template>



<style lang="sass" scoped>

.instructions

.input-field
  input
    width: 99%
    margin: 0px !important
    padding: 0px !important

.youtube
  width: 60%
  text-align: left
  margin: 0 auto
  border: thin solid gray
  padding: 10px

@media screen and (max-width: 1200px)  
  .youtube
    width: 100%

pre
  white-space: pre-wrap;       /* Since CSS 2.1 */
  white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
  white-space: -pre-wrap;      /* Opera 4-6 */
  white-space: -o-pre-wrap;    /* Opera 7 */
  word-wrap: break-word;       /* Internet Explorer 5.5+ */  


/*****************************************/
//Video css
/*****************************************/

#no-video 
  margin: .5em 1.5em 1.5em 1.5em;
  background-color: #f1f1f1;
  height: 250px;
  text-align: center;

.no-video-view-only
  text-align: center

#video 
  position: relative;
  margin: 1.5em .5em .5em .5em;
  background-color: #f1f1f1;
  height: 0;
  padding: 0; //resets settings in educ.css
  padding-bottom: 56.25%;
  overflow: hidden;



iframe 
  position: absolute;
  height: 100% !important;
  width: 100% !important;


#no-video .row 
  text-align: center;


#no-video .row span 
  font-size: 12px;


#video-div 
  margin-top: 2em;
  padding: .5em;
  background-color: #fff;



.add-video-icon 
  width: 50px;
  height: 50px;


/*****************************************/
//company video modal
/*****************************************/

#company-video 
  background-color: #d3d3d3;


.input-field .btn 
  background-color: #c0c0c0;
  color: #000;
  box-shadow: none;
  border: 1px solid #000;

</style>